(function ErezReportFutureAirDepositsForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FutureAirDeposit',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.delete-hoops-attachment').on('click', function deleteHoopAttachment(event) {
			var self = this;

			event.preventDefault();

			$(this).blur(); // make sure tooltip is hidden after clicking confirm message

			Adzuki.CustomConfirm({
				body   : 'Are you sure you want to delete this attachment? This action CANNOT be undone.',
				confirm: function yes() {
					Adzuki.Ajax.post('/FutureAirDeposits/deleteAttachment', {
						id: $(self).data('hoop-id')
					})
					.then(function clearExistingAttachment(data) {
						$('#current-fad-attachment').remove();
						Adzuki.StatusMessage('success', 'The attachment has been removed from the future credit.');
					});
				}
			});
		});

		$('.unlink-reservation').on('click', function unlinkReservation(event) {
			event.preventDefault();

			Adzuki.CustomConfirm({
				body   : 'Are you sure you want to unlink the reservation from this future credit?',
				confirm: function yes() {
					$('#futureairdeposit-reservation_id').val('');
					$('.reservation-info').addClass('hidden');
					$('.reservation-search').removeClass('hidden');
				}
			});
		});

		Adzuki.Typeahead(
			'.deposit-reservation-autocomplete',
			function search(term, display, $self)
			{
				var _request = Adzuki.Ajax.get('/Reservations/autocomplete/' + term + '/0');
				_request.then(function searchResults(response)
				{
					display(response);
				})
				.catch(function searchError()
				{
					$self.removeClass('ajax-spinner');
					display([{name: "Error searching for reservations."}]);
				});
			},
			function select(item) {
				if (item.id !== null) {
					$('.deposit-reservation-autocomplete').removeClass('ajax-spinner');
					$('#futureairdeposit-reservation_id').val(item.id);
				}
			}
		);
	};

}(jQuery, window.Adzuki || {}));